import { render, staticRenderFns } from "./Postsco.vue?vue&type=template&id=6e423884&"
import script from "./Postsco.vue?vue&type=script&lang=js&"
export * from "./Postsco.vue?vue&type=script&lang=js&"
import style0 from "./Postsco.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports